import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg">
                <span className="text-white font-bold text-xl">JLD</span>
              </div>
              <span className="font-bold text-xl">JLD Concept</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Votre partenaire de confiance pour les solutions télécom et énergie en Belgique
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Télécom
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Énergie
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Entretien Chaudière
                </Link>
              </li>
              <li>
                <Link to="/devenir-consultant" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Consulting
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Entreprise</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/a-propos" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  À Propos
                </Link>
              </li>
              <li>
                <Link to="/partenariats" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Partenaires
                </Link>
              </li>
              <li>
                <Link to="/devenir-consultant" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Carrières
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-lg mb-4">Légal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/conditions" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Conditions Générales
                </Link>
              </li>
              <li>
                <Link to="/conditions" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Confidentialité
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
              © 2025 JLD Concept SRL. Tous droits réservés.
            </div>
            <div className="flex items-center space-x-6">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-orange-500 transition-colors"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-orange-500 transition-colors"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-orange-500 transition-colors"
                aria-label="Instagram"
              >
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a
                href="mailto:jld@danko.be"
                className="text-gray-400 hover:text-orange-500 transition-colors"
                aria-label="Email"
              >
                <i className="ri-mail-fill text-xl"></i>
              </a>
            </div>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-gray-500 hover:text-gray-400 transition-colors whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}